import axios from 'axios'
import notification from 'ant-design-vue/es/notification'
import {getInfo} from '../module/login/ApiLogin'

export const baseURL= 'http://49.4.66.163:8000';
// 创建 axios 实例
const request = axios.create({
    // API 请求的默认前缀
    // baseURL: 'http://192.168.10.122:5000',
    // baseURL: 'http://192.168.10.13:8004',
    timeout: 60000, // 请求超时时间
    baseURL,
    method: 'post'
});

// 异常拦截处理器
const errorHandler = (error) => {
    if (error.response) {
        switch (error.response.status) {
            case 500:
                notification.error({
                    message: '服务器错误，请联系管理员解决',
                });
                break;
            case 400:
                notification.error({
                    message: '请求参数和服务器接收参数类型不一样，请联系管理员解决',
                });
                break;
            case 401:
                window.location.href = '/';
                notification.error({
                    message: '登录过期',
                    description: '登录状态已超过30分钟，请重新登录'
                });
                break;
        }
    }
    return Promise.reject(error)
};
/**
 * request 请求拦截处理
 */
request.interceptors.request.use(config => {
    const user = getInfo();
    // 如果 用户 存在
    // 让每个请求携带自定义 token 请根据实际情况自行修改
    if (user) {
        config.headers['Authorization'] = 'Bearer ' + user.token
    }
    return config
}, null);
/**
 * response 响应拦截处理
 */
request.interceptors.response.use((response) => {
    if (response.data.status === 0) {
        return response.data
    } else {
        if (response.data.message === '登录过期') {
            window.location.href = '/';
            notification.error({
                message: '登录过期',
                description: '登录状态已超过30分钟，请重新登录'
            });
        }
        notification.error({
            message: '错误',
            description: response.data.message
        });
        return Promise.reject(response)
    }
}, errorHandler);


export default request

